import React from 'react';
import { RecuperarAmbiente } from '@services/auth';
import Marquee from 'react-fast-marquee';

const EnvironmentTag = () => {
  const Environment = RecuperarAmbiente();

  return (
    <>
      {Environment === 'development' && (
        <div className="d-flex align-items-center justify-content-center bg-danger w-100" style={{ height: '30px', backgroundColor: '#dc3545' }}>
          <Marquee direction={'right'} gradient={false} speed={60} style={{ paddingTop: '2.5px' }}>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de desenvolvimento{`ㅤ`}</span>
          </Marquee>
        </div>
      )}
      {Environment === 'staging' && (
        <div className="d-flex align-items-center justify-content-center bg-danger w-100" style={{ height: '30px', backgroundColor: '#dc3545' }}>
          <Marquee direction={'right'} gradient={false} speed={60}>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de testes{`ㅤ`}</span>
          </Marquee>
        </div>
      )}
      {Environment === 'hml' && (
        <div className="d-flex align-items-center justify-content-center bg-danger w-100" style={{ height: '30px', backgroundColor: '#dc3545' }}>
          <Marquee direction={'right'} gradient={false} speed={60}>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
            <span className="pl-4 text-white text-uppercase fs-13 text-monospace">{`ㅤ`}Você está em um ambiente de homologação{`ㅤ`}</span>
          </Marquee>
        </div>
      )}
      {Environment === 'production' && <></>}
      {!Environment && <></>}
    </>
  );
};

export default EnvironmentTag;
